<template>
  <BasePopup ref="popup" title="Change password" class="popup--simple">
    <div class="sign-up">
      <form class="shortform-sign-up__form" @submit.prevent="submitForm">
        <fieldset id="support-edit-form-group-subject" class="form__group">
          <div tabindex="-1" role="group">
            <label class="form__label form__label--large">
              Current password
            </label>
            <InputWithContextMenu
              id="old-password-field"
              ref="oldPasswordInput"
              v-model="view.model.old_password"
              type="password"
              autocomplete="password"
              placeholder=""
              autofocus
              class="form-control"
            />
            <FormError :errors="view.validation.errors" field="old_password" />
          </div>
          <div tabindex="-1" role="group">
            <label class="form__label form__label--large">New password</label>
            <InputWithContextMenu
              id="password-field"
              ref="passwordInput"
              v-model="view.model.password"
              type="password"
              autocomplete="new-password"
              placeholder=""
              class="form-control"
            />
            <FormError :errors="view.validation.errors" field="password" />
          </div>
        </fieldset>
        <div class="shortform-sign-up__group">
          <AppButton
            id="password-change-submit"
            class="app-btn btns--yellow"
            type="submit"
          >
            Save Changes
          </AppButton>
        </div>
      </form>
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import FormError from '@/components/ui/FormError.vue'

const popup = ref<InstanceType<typeof BasePopup> | null>(null)
const oldPasswordInput = ref<InstanceType<typeof InputWithContextMenu> | null>(
  null,
)
const passwordInput = ref<InstanceType<typeof InputWithContextMenu> | null>(
  null,
)

import { ChangePasswordPopupView } from '@/models/settings'
const view = ref(new ChangePasswordPopupView())

async function show(): Promise<void> {
  view.value.validation.reset()
  await view.value.init()
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

async function submitForm(): Promise<void> {
  await view.value.submitForm()
  if (isSuccess()) {
    hide()
  }
}

function isSuccess(): boolean {
  return view.value.state === 'success'
}

defineExpose({
  show,
  hide,
  isSuccess,
})
</script>
